import React from 'react';
import AccreditedNetworkScreen from '../components/AccreditedNetworkNew/AccreditedNetworkScreen';

import '../assets/css/accredited_network_new.css';


const AccreditedNetworkNew = () => {

  return (
    <div>
      <AccreditedNetworkScreen />
    </div>
  );
};

export default AccreditedNetworkNew;


/** WEBPACK FOOTER **
 ** ./src/containers/AccreditedNetworkNew.js
 **/